import React from 'react'
const Footer = (props) =>{
    return(
        <div className = 'footer'>
            Created by Christopher Johnson
        </div>
    )
}
export default Footer